import apiService from "./apiService"
import { TimezoneModel } from "../models/TimezoneModel";

const timezoneService = {
    getTimezones: async () => {
        let timezones = await apiService.get("/Timezone");
        return (timezones as TimezoneModel[]).map((x) => new TimezoneModel(x));
    }
} 

export default timezoneService;